import type { JSX } from 'react';
import commun from './commun.module.css';
import styles from './ListeBarres.module.css';

export interface LigneBarre {
  cle: string;
  libelle: string;
  /** Le score en gros : « 11 sur 14 », « 14 ». */
  score: string;
  /** Le complément, en petit : « 79 % ». */
  detail?: string;
  /** La part (0 à 1) : la longueur de la barre. */
  ratio: number;
  couleur?: 'vert' | 'ambre' | 'gris' | 'encre';
}

/**
 * Une liste de barres horizontales : un libellé, une piste, un score. Le
 * texte porte l'information (score et pourcentage) ; la piste est décorative.
 */
export function ListeBarres({
  lignes,
  etiquette,
}: {
  lignes: LigneBarre[];
  etiquette?: string;
}): JSX.Element {
  return (
    <ul className={styles.liste} aria-label={etiquette}>
      {lignes.map((ligne) => (
        <li key={ligne.cle}>
          <span>{ligne.libelle}</span>
          <span className={styles.piste} aria-hidden="true">
            <i
              className={ligne.couleur ? styles[ligne.couleur] : undefined}
              style={{ width: `${Math.max(0, Math.min(1, ligne.ratio)) * 100}%` }}
            />
          </span>
          <span className={`${commun.num} ${styles.score}`}>
            {ligne.score}
            {ligne.detail ? <small>{ligne.detail}</small> : null}
          </span>
        </li>
      ))}
    </ul>
  );
}
